import Column from '@app/components/layout/Column'
import { useTranslations } from '@i18n/useLanguage'
import { TabsGroup } from '@app/components/core/tabs/Tabs'
import { match } from 'ts-pattern'
import { useParamState } from '@app/util/hooks/useParamState'
import {
  topicCommunityTabs,
  topicCommunityTabsQueryParamName,
} from './constants'
import { Thread } from '@app/components/blocks/thread/Thread'
import { ViewTopicCommunityModel } from 'functions/app/topic-community/view'
import { TopicCommunityPageOverview } from './sections/Overview'
import { TopicCommunityPageInitiatives } from './sections/Initiatives'
import { TopicCommunityPageKnowledgeHub } from './sections/KnowledgeHub'
import { TopicCommunityPageEvents } from './sections/Events'
import { TopicCommunityPageContact } from './sections/Contact'

export const TabContent = ({
  topicCommunity,
}: {
  topicCommunity: ViewTopicCommunityModel
}) => {
  const t = useTranslations().app.topicCommunityPage.tabs

  const [tab, setTab] = useParamState(
    topicCommunityTabs,
    topicCommunityTabsQueryParamName,
  )

  return (
    <Column alignItems="stretch" gap="2rem" style={{ width: '100%' }}>
      <TabsGroup
        selectedTab={tab}
        onSelectTab={setTab}
        tabs={[
          { label: t.overview, value: topicCommunityTabs.overview },
          { label: t.discussion, value: topicCommunityTabs.discussion },
          { label: t.initiatives, value: topicCommunityTabs.initiatives },
          {
            label: t.knowledgeHub,
            value: topicCommunityTabs.knowledgeHub,
            isVisible: (topicCommunity.knowledgeHubModules?.length ?? 0) > 0,
          },
          { label: t.events, value: topicCommunityTabs.events },
          { label: t.contactInfo, value: topicCommunityTabs.contactInfo },
        ]}
      />

      {match(tab)
        .with(topicCommunityTabs.overview, () => (
          <TopicCommunityPageOverview topicCommunity={topicCommunity} />
        ))
        .with(topicCommunityTabs.discussion, () =>
          topicCommunity.thread ? (
            <Thread
              key="thread"
              threadId={topicCommunity.thread.id}
            />
          ) : null,
        )
        .with(topicCommunityTabs.initiatives, () => (
          <TopicCommunityPageInitiatives topicCommunity={topicCommunity} />
        ))
        .with(topicCommunityTabs.knowledgeHub, () => (
          <TopicCommunityPageKnowledgeHub topicCommunity={topicCommunity} />
        ))
        .with(topicCommunityTabs.events, () => (
          <TopicCommunityPageEvents topicCommunity={topicCommunity} />
        ))
        .with(topicCommunityTabs.contactInfo, () => (
          <TopicCommunityPageContact topicCommunity={topicCommunity} />
        ))
        .exhaustive()}
    </Column>
  )
}
